export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
            <path
                d="M35.4917 53.1578H28.4723C27.4652 53.1578 26.4993 52.7573 25.7869 52.0442C25.0746 51.331 24.6742 50.3636 24.6742 49.3547V41.0375H39.2898V49.3547C39.2898 50.3636 38.8895 51.331 38.1771 52.0442C37.4648 52.7573 36.4988 53.1578 35.4917 53.1578Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.4096 34.5921L41.5517 28.9659C42.0444 28.8279 42.5717 28.8916 43.0175 29.1429C43.4632 29.3941 43.7911 29.8124 43.9288 30.3056C44.0666 30.7988 44.003 31.3267 43.752 31.773C43.5011 32.2193 43.0833 32.5475 42.5906 32.6854L22.4484 38.3116C21.9558 38.4495 21.4285 38.3858 20.9827 38.1346C20.5369 37.8833 20.2091 37.4651 20.0713 36.9719C19.9336 36.4786 19.9972 35.9508 20.2482 35.5045C20.4991 35.0582 20.9169 34.73 21.4096 34.5921Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.4096 26.5969L41.5517 20.9635C42.0393 20.8442 42.554 20.9195 42.9872 21.1733C43.4203 21.4271 43.7379 21.8395 43.8728 22.3235C44.0078 22.8075 43.9494 23.325 43.7101 23.7666C43.4708 24.2083 43.0694 24.5395 42.5906 24.6902L22.4484 30.3165C21.9558 30.4544 21.4285 30.3907 20.9827 30.1394C20.5369 29.8882 20.2091 29.4699 20.0713 28.9767C19.9336 28.4835 19.9972 27.9556 20.2482 27.5094C20.4991 27.0631 20.9169 26.7349 21.4096 26.5969Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M23.6473 38.0013L26.6644 40.8991" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M28.0543 37.0695L31.7909 40.8992" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M39.4948 33.8264L41.4787 35.8053C41.5485 35.8727 41.604 35.9535 41.642 36.0428C41.6799 36.1322 41.6995 36.2283 41.6995 36.3254C41.6995 36.4224 41.6799 36.5185 41.642 36.6079C41.604 36.6972 41.5485 36.778 41.4787 36.8454L37.43 40.8991"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35.3552 34.9387L36.5888 36.2315C36.6564 36.2987 36.7101 36.3785 36.7467 36.4666C36.7834 36.5546 36.8022 36.649 36.8022 36.7443C36.8022 36.8397 36.7834 36.9341 36.7467 37.0221C36.7101 37.1101 36.6564 37.19 36.5888 37.2571L32.8162 40.8992"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.4096 18.4647L41.5517 12.8384C42.0246 12.75 42.5135 12.8419 42.9221 13.0961C43.3307 13.3502 43.6295 13.7483 43.7598 14.2119C43.89 14.6755 43.8423 15.1712 43.6259 15.6013C43.4095 16.0315 43.0402 16.365 42.5906 16.5363L22.4484 22.1625C21.9558 22.3004 21.4285 22.2368 20.9827 21.9855C20.5369 21.7343 20.2091 21.316 20.0713 20.8228C19.9336 20.3295 19.9972 19.8017 20.2482 19.3554C20.4991 18.9091 20.9169 18.5809 21.4096 18.443V18.4647Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M38.6881 6.35258C38.9873 6.56242 39.2207 6.85309 39.3611 7.19069C39.5015 7.52829 39.5431 7.89889 39.4811 8.25928C39.4191 8.61966 39.256 8.95496 39.0109 9.22607C38.7657 9.49717 38.4486 9.6929 38.0966 9.79043L27.5926 12.7299C27.3487 12.7982 27.0937 12.8177 26.8422 12.7874C26.5907 12.757 26.3477 12.6773 26.1269 12.5529C25.9062 12.4285 25.7121 12.2618 25.5557 12.0623C25.3993 11.8628 25.2838 11.6344 25.2155 11.3902C25.1473 11.146 25.1278 10.8907 25.1582 10.6389C25.1885 10.3871 25.2681 10.1438 25.3924 9.92283C25.5166 9.70185 25.6832 9.50753 25.8824 9.35098C26.0817 9.19443 26.3098 9.0787 26.5538 9.01041L37.0505 6.07091C37.3273 5.99406 37.6177 5.97946 37.9008 6.02816C38.184 6.07686 38.4528 6.18764 38.6881 6.35258Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35.8939 53.1312V54.4538C35.8939 54.9201 35.802 55.3818 35.6236 55.8125C35.4451 56.2432 35.1836 56.6345 34.8539 56.9639C34.5242 57.2932 34.1329 57.5543 33.7023 57.7321C33.2717 57.9099 32.8103 58.0009 32.3445 57.9999H31.6231C30.683 58 29.7813 57.6266 29.1158 56.9617C28.4504 56.2969 28.0756 55.3949 28.0737 54.4538V53.1312"
                stroke="black"
                strokeWidth="1.40725"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
